module.exports = __webpack_public_path__ + "static/media/mujahid.b6036f11.jpg";